import styled from "styled-components";

export const AuthModalHeaderLogoContainer = styled.div`
  display: grid;
  place-items: center;
  margin-bottom: 1rem;

  .auth-modal-logo {
    object-fit: contain;
  }

  .auth-modal-header-logo-title {
    all: unset;
    color: ${({ theme }) => theme.authModal.primaryText};
    font: 600 1.375rem/1.688rem "Inter";
  }
`;
